// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 使用ElementUI
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router, // 确保这里注入了router
  store,
  render: h => h(App)
}).$mount('#app')